// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Tp1u","col":"styles_col__2k6Vm"};